import client_core from "@/services/clients/client_core";

const PriceListService = {
    getPriceLists(picaServiceId) {
        let url = '/dashboard/v1/price-lists/?page_size=200'
        if (picaServiceId)
            url += `?pica_service=${picaServiceId}`
        return client_core.get(url)
    },

    getPricelistById(picaServiceId, priceListId) {
        return client_core.get(`/dashboard/v1/price-lists/${priceListId}/?pica_service=${picaServiceId}`)
    },

    getCurrencies() {
        return client_core.get('/dashboard/v1/currencies/')
    }
}

export default PriceListService